/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminAuthChangePasswordRequest
 */
export interface AdminAuthChangePasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminAuthChangePasswordRequest
     */
    newPassword: string;
    /**
     * 
     * @type {string}
     * @memberof AdminAuthChangePasswordRequest
     */
    oldPassword: string;
}

export function AdminAuthChangePasswordRequestFromJSON(json: any): AdminAuthChangePasswordRequest {
    return AdminAuthChangePasswordRequestFromJSONTyped(json, false);
}

export function AdminAuthChangePasswordRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminAuthChangePasswordRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'newPassword': json['new_password'],
        'oldPassword': json['old_password'],
    };
}

export function AdminAuthChangePasswordRequestToJSON(value?: AdminAuthChangePasswordRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'new_password': value.newPassword,
        'old_password': value.oldPassword,
    };
}

